export const PERSONA_QUERIES = {
  GET_PERSONAS: `
    query GetPersonas($limit: Int!, $cursor: String) {
      personas(limit: $limit, cursor: $cursor) {
        pageInfo {
          nextCursor
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            name
            gender
            age
            hairColor
            eyeColor
            hairStyle
            bodyType
            ethnicity
            additionalDetails
            mainImageUrl
            mainImageUrlThumbnail
            isMine
            isPublic
            countTrainingCompleted
            countTrainingProcessing
            countImageInferences
            countVideoInferences
            countAudioInferences
          }
        }
      }
    }
  `,

  GET_PERSONA: `
    query GetPersona($id: ID!) {
      persona(id: $id) {
        id
        name
        gender
        age
        hairColor
        eyeColor
        hairStyle
        bodyType
        ethnicity
        additionalDetails
        mainImageUrl
        mainImageUrlThumbnail
        isMine
        isPublic
        medias(limit: 50) {
          edges {
            node {
              id
              name
              url
              urlThumbnail
              extension
              personaId
            }
          }
          pageInfo {
            hasNextPage
            nextCursor
          }
        }
        countTrainingCompleted
        countTrainingProcessing
        countImageInferences
        countVideoInferences
        countAudioInferences
      }
    }
  `,

  GET_MEDIA_INFERENCES: `
    query GetMediaInferences($personaId: ID!, $mediaType: String, $limit: Int!, $cursor: String) {
      mediaInferences(
        personaId: $personaId, 
        mediaType: $mediaType, 
        limit: $limit, 
        cursor: $cursor
      ) {
        pageInfo {
          nextCursor
          hasNextPage
        }
        edges {
          cursor
          node {
            id
            name
            displayName
            url
            urlThumbnail
            extension
            inferenceId
            personaId
            createdAt
          }
        }
      }
    }
  `,
};
